export const IMAGES_PER_PAGE = 18
export const FILES_PER_PAGE = 18
